import { render } from "./CommonPage.vue?vue&type=template&id=13e14fb0&scoped=true&ts=true"
import script from "./CommonPage.vue?vue&type=script&lang=ts"
export * from "./CommonPage.vue?vue&type=script&lang=ts"

import "./CommonPage.vue?vue&type=style&index=0&id=13e14fb0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e14fb0"]])

export default __exports__